<template>
  <div class="yunxiao teacher channel-config">
    <van-tabs class="van-hairline--bottom" v-model="activeTab">
      <van-tab
        title="全部商户"
        :name="0"
        v-if="app.permission.op('company_merchant_list')">
      </van-tab>
      <van-tab
        title="校区商户"
        :name="1"
        v-if="app.permission.op('campus_merchant_list')">
      </van-tab>
    </van-tabs>
    <div class="total-nav" v-if="activeTab == 0 && list.length>0">共{{list.length}}条</div>
    <div v-if="activeTab == 1" class="campus-nav flex-between">
      <div class="filter-campus" @click="x3ChooseCampus">
        <span class="van-ellipsis">{{ params.campusName }}</span>
        <van-icon
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g5)"
        />
      </div>
      <div>一个校区只能启用一个收款商户</div>
    </div>
    <div class="channel-config-content">
      <template v-if="activeTab == 0">
        <div class="box"
          v-for="(item,idx) of list" 
          :key="idx"
          @click="toChannelDetail(item)">
          <div class="box-title flex-between">
            <div>{{item.subMchShortName}}</div>
            <van-icon name="arrow" color="var(--g6)"></van-icon>
          </div>
          <div class="van-hairline--top">
            <div class="box-line flex-between">
              <div class="bl-label">结算渠道</div>
              <div class="bl-value">{{item.payChannelName}}
                <span class="tag">{{privateMap[item.isPrivate]}}</span>
              </div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">收费管家商户号</div>
              <div class="bl-value">{{item.merchantId}}</div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">结算方式</div>
              <div class="bl-value">{{item.bankName}}</div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">账号</div>
              <div class="bl-value">{{item.bankCardno}}</div>
            </div>
          </div>
          <div class="van-hairline--top box-bottom">
            <div class="box-line flex-between">
              <div class="bl-label">授权校区</div>
              <div class="bl-value van-ellipsis">{{item.merchantCampusRelationList.map(i=>i.campusName).join('、')}}</div>
            </div>
          </div>
        </div>
        <van-empty
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          v-if="list.length === 0 && !isLoading"
          image-size="128">
          <template #description>
            <div style="text-align: center;">
              暂无可配置线上收款商户 <br>
              请先开通收费管家
            </div>
          </template>
          <van-button
            square round
            type="primary"
            @click="toOpenSfgj"
          >
            开通收费管家
          </van-button>
        </van-empty>
      </template>
      <template v-if="activeTab == 1">
        <div class="box"
          v-for="(item,idx) of list" 
          :class="{'is-current': item.merchantCampusRelationList.length>0 && item.merchantCampusRelationList[0].enable == 1}"
          :key="idx">
          <div class="box-title1 van-ellipsis">{{item.subMchShortName}}</div>
          <div class="van-hairline--top">
            <div class="box-line flex-between">
              <div class="bl-label">结算渠道</div>
              <div class="bl-value">{{item.payChannelName}}
                <span class="tag">{{privateMap[item.isPrivate]}}</span>
              </div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">收费管家商户号</div>
              <div class="bl-value">{{item.merchantId}}</div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">结算方式</div>
              <div class="bl-value">{{item.bankName}}</div>
            </div>
            <div class="box-line flex-between">
              <div class="bl-label">账号</div>
              <div class="bl-value">{{item.bankCardno}}</div>
            </div>
          </div>
          <div class="van-hairline--top box-btn"
            @click="switchChannel(item)"
            v-if="item.merchantCampusRelationList[0].enable == 0">
            设为当前收款商户
          </div>
        </div>
        <van-empty
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          v-if="list.length === 0 && !isLoading"
          image-size="128">
          <template #description>
            <div style="text-align: center;">
              暂无可设置的商户<br>
              请先在<span style="color: var(--g7)">【全部商户】</span>中为校区授权商户
            </div>
          </template>
        </van-empty>
      </template>
    </div>
  </div>
</template>

<script>
import toOpenSfgj from '@teacher/views/wallet/to-open-sfgj-mixin';

export default {
  name: 'sf-set-channel',
  mixins: [toOpenSfgj],
  data: () => {
    return {
      pageTitle: '线上收款商户设置',
      activeTab: 0,
      list: [],
      isLoading: false,
      privateMap: {
        0: '法人对公',
        1: '法人对私',
        2: '非法人对私'
      },
      params: {
        campusId: app.teacher.campusId, //校区id
        campusName: app.teacher.campus.name,
      }
    }
  },
  watch: {
    activeTab: {
      handler: function (nv, ov) {
        if (nv != ov) {
          this.getInfos();
        }
      }
    },
  },
  methods: {
    getInfos () {
      let apiParams = this.activeTab == 0 ? {} : this.params;
      this.showLoading();
      this.isLoading = true;
      this.list = [];
      this.$api.findMerchantList(apiParams).then(res=> {
        this.isLoading = false;
        this.$toast.clear();
        if (res.code === 200) {
          this.list = res.data.merchantList;
        }
        if (res.code > 60000) {
          this.$toast.fail(res.msg || '网络异常，请稍后重试');
        }
      })
    },
    toChannelDetail(item) {
      this.$router.push(`/sf/set/channel/detail?companyMerchantId=${item.id}`);
    },
    async x3ChooseCampus() {
      let res = await app.x3.side.xsCampus({
        id: this.params.campusId,
        config: {
          must: true,
        },
      });
      this.params.campusId = res.id;
      this.params.campusName = res.name;
      this.getInfos();
    },
    switchChannel(toItem) { // 设置校区当前商户
      let toItemName = `${toItem.payChannelName}-${toItem && toItem.isPrivate ? this.privateMap[toItem.isPrivate] : ''}`;
      this.$dialog.confirm({
        message: `是否确认设置[${toItemName}]渠道进行校区线上收款？`,
        cancelButtonText: '取消',
        confirmButtonText: '确认',
      }).then(() => {
        this.showLoading();
        this.$api.addCampusCurrentMerchant({
          campusId: this.params.campusId,
          companyMerchantId: toItem.id
        })
          .then(res => {
            if (res && res.code === 200) {
              this.$toast.clear();
              this.getInfos();
              this.$toast.success('设置成功');
              return false;
            }
            if (res.code > 60000) {
              this.$toast.fail(res.msg || '网络异常，请稍后重试');
            }
          })
          .catch ( () => {
            console.log('切换商户号出错了。');
          });
      }).catch(()=>{
        console.log('取消操作');
      });  
    },
  },
  created () {
    this.activeTab = parseInt(this.$route.query.active) || 0;
    if (this.$route.query && this.$route.query.campusId) {
      this.params.campusId = this.$route.query.campusId
      this.params.campusName = app.teacher.campusMap[this.$route.query.campusId].name;
    }
    this.getInfos();

    this.$onBus("refresh-sf-set-channel", () => {
      this.getInfos();
    });
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.channel-config{
  display: flex;
  flex-direction: column;
  .total-nav {
    padding: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 4) calc(var(--gap) * 16);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--g6);
  }
  .campus-nav {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--g6);
    .filter-campus {
      flex: 1;
      display: flex;
      align-items: center;
      margin-right: calc(var(--gap) * 10);
      overflow: hidden;
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g8);
    }
  }
  .channel-config-content {
    flex: 1;
    overflow-y: auto;
    .box {
      margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
      padding: 0 calc(var(--gap) * 16);
      background-color: var(--white);
      border-radius: var(--radius-sm);
      .box-title,
      .box-title1 {
        padding: calc(var(--gap) * 12) 0;
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        color: var(--g8);
        font-weight: var(--bold);
      }
      .box-title1 {
        padding-right: 60px;
      }
      .box-line {
        display: flex;
        padding: calc(var(--gap) * 6) 0;
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        .bl-label {
          margin-right: calc(var(--gap) * 10);
          flex-shrink: 0;
          color: var(--g6);
        }
        .bl-value {
          color: var(--black);
          .tag {
            padding: 0 calc(var(--gap) * 4);
            color: var(--c1);
            border: 1px solid var(--c1);
            border-radius: calc(var(--radius-base) / 2);
          }
        }
      }
      .box-bottom {
        padding: calc(var(--gap) * 6) 0;
      }
      .box-btn {
        padding: calc(var(--gap) * 12) 0;
        text-align: center;
        color: var(--c1);
        font-weight: var(--bold);
      }
      &.is-current {
        position: relative;
        border: 2px solid var(--c1);
        &::after {
          position: absolute;
          top: 0;
          right: 0;
          content: '当前收款商户';
          padding: calc(var(--gap) * 3) calc(var(--gap) * 6);
          background-color: var(--c1);
          color: var(--white);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          border-bottom-left-radius: var(--radius-sm);
        }
        .box-line {
          &:last-child {
            padding-bottom: calc(var(--gap) * 12);
          }
        }
      }
    }
  }
}
</style>